module.exports = __webpack_public_path__ + "img/relogio.44968175.svg";